import { FC, useRef, useState } from 'react';
import styles from './MoreActionsMenu.styles';
import { MoreActionsMenuProps } from './MoreActionsMenu.types';
import MoreActionsMenuItem from './MoreActionsMenuItem';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon';
import IconButton from 'yoda-ui/components/Icons/IconButton';
import Menu from 'yoda-ui/components/Menu';

const isLast = (index: number, arr: unknown[]) => index >= arr.length - 1;

const MoreActionsMenu: FC<MoreActionsMenuProps> = ({ menuItemConfigs }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const getAnchorPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const offset = 10;

      return {
        top: rect.bottom,
        left: rect.right + offset,
      };
    }
    return undefined;
  };

  const menuItems = menuItemConfigs.map((menuItemConfig, index) => (
    menuItemConfig?.hideItem ? null : (<MoreActionsMenuItem
      key={ menuItemConfig?.id || menuItemConfig?.label }
      menuItemConfig={ menuItemConfig }
      isLast={ isLast(index, menuItemConfigs) }
      closeMenu={ () => setOpen(false) }
    />)
  ));

  return (
    <>
      <IconButton ref={ buttonRef } onClick={ () => setOpen(true) }>
        <Icon
          name={ Icons.moreVertical }
          fontSize='large'
        />
      </IconButton>
      <Menu
        anchorPosition={ open ? getAnchorPosition() : undefined }
        anchorReference="anchorPosition"
        anchorOrigin={
          {
            vertical: 'bottom',
            horizontal: 'right',
          }
        }
        transformOrigin={
          {
            vertical: 'top',
            horizontal: 'right',
          }
        }
        sx={ styles.menu }
        open={ open }
        onClose={ () => setOpen(false) }
      >
        { menuItems }
      </Menu>
    </>
  );
};

export default MoreActionsMenu;
